
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { BackgroundGradient } from "@/components/ui/background-gradient";
import Hero from "./LandingPage/Hero";
import Mission from "./LandingPage/Mission";
import RevolutionaryApproach from "./LandingPage/RevolutionaryApproach";
import PledgeSection from "./LandingPage/PledgeSection";
import Footer from "./LandingPage/Footer";
import { Helmet } from "react-helmet-async";

const LandingPage = () => {
  const navigate = useNavigate();

  const handlePledge = () => {
    // Scroll to the pledge section
    const pledgeSection = document.getElementById("pledge-section");
    if (pledgeSection) {
      pledgeSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Structured data for better SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "cheqbooq",
    "description": "A financial platform that empowers users with control over their financial data.",
    "url": "https://cheqbooq.com",
    "logo": "https://cheqbooq.com/logo.png",
    "founders": [
      {
        "@type": "Person",
        "name": "cheqbooq Founder"
      }
    ],
    "knowsAbout": [
      "Financial Data",
      "Personal Finance",
      "Financial Analysis",
      "Financial Transparency"
    ],
    "sameAs": [
      "https://twitter.com/cheqbooq",
      "https://linkedin.com/company/cheqbooq"
    ]
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>cheqbooq - Your Money, Your Data, Your Future</title>
        <meta name="description" content="We believe in a financial world where the power of your data serves you, not corporations. Join the movement today." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Header */}
      <header className="border-b border-border/20 backdrop-blur-lg bg-background/80 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto flex justify-between items-center py-5 px-6">
          <h1 className="text-2xl font-display font-medium text-foreground tracking-tight">
            cheqbooq
          </h1>
          <div className="flex items-center gap-4">
            <Button 
              onClick={handlePledge}
              className="flex items-center gap-2"
            >
              Join the Movement
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <BackgroundGradient className="py-32 px-6 relative" variant="subtle">
        <Hero onPledge={handlePledge} />
      </BackgroundGradient>

      {/* Mission Section */}
      <Mission />

      {/* Revolutionary Approach Section */}
      <RevolutionaryApproach />

      {/* Pledge Section */}
      <PledgeSection id="pledge-section" />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
